import { Form, Input } from "antd";
import React from "react";

const DomainName: React.FC = () => {
  return (
    <Form.Item name="domainName" label="Domain Name">
      <Input />
    </Form.Item>
  );
};

export default DomainName;
